<template>
  <v-card v-if="loading" class="control-card preload-box h-100 pa-2 " style="min-height: 380px;">
    <v-progress-circular indeterminate color="primary" class="h-100"></v-progress-circular>
  </v-card>
  <v-card v-else class="control-card control-card--services">
    <div>
      <p class="control-card__title mb-3">Диктор: станции</p>
      <div v-for="card, index in dictorStations" :key="index" class="control-card--small mt-2"
        :style="{ 'border-color': card.status === 'on' ? '#4caf50' : '#f44336' }">
        <p>{{ card.name || '-' }}</p>
        <div style="display: flex; align-items: center; gap: 8px; margin-left: auto;">
          <p v-if="card.status === 'on'" class="green--text ma-0">ONLINE</p>
          <p v-if="card.status === 'off'" class="red--text ma-0">OFFLINE</p>
          <div v-if="card.status === 'on'" class="control-card__message">{{ card.value || 0 }}</div>
        </div>
      </div>
    </div>
    <div>
      <p class="control-card__title mb-3">Роботы</p>
      <div class="control-services__cards">
        <div v-for="card, index in servicesStatus" :key="index" class="control-card--small"
          :style="{ 'border-color': card.value === 'on' ? '#4caf50' : '#f44336' }">
          <p>{{ card.name || '-' }}</p>
          <p v-if="card.value === 'on'" class="green--text" style="margin-left: auto;">ONLINE</p>
          <p v-if="card.value === 'off'" class="red--text" style="margin-left: auto;">OFFLINE</p>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import store from '@/store'

export default {
  props: ['loading'],
  data: () => ({
  }),
  computed: {
    controlsData() {
      return store.getters['controls/getControls']
    },
    dictorStations() {
      return this.controlsData.dictor_stations || []
    },
    servicesStatus() {
      return this.controlsData.services_status || []
    }
  }
}
</script>
